import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: 'https://api-gpf-hr.zwiz.app/hopinnhr',
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const hopinnHrApi = {
  getAffiliation: () => {
    return instance().get('/v2/getAffiliationMaster')
  },
  getDivision: () => {
    return instance().get('/v2/getDivisionMaster')
  },
  getDepartment: () => {
    return instance().get('/v2/getDepartmentMaster')
  },
  getStatus: () => {
    return instance().get('/v2/getStatusMaster')
  },
  getPosition: () => {
    return instance().get('/v2/getPositionMaster')
  },
  postCreateSop: (request) => {
    const { data } = request
    return instance().post('/v2/createSop', data)
  },
  getSopListing: (request) => {
    const { config } = request
    return instance().get('/v2/getSop', config)
  },
  deleteSop: (request) => {
    const { data } = request
    return instance().delete(`/v2/deleteSop/${data.id}`)
  },
  updateSop: (request) => {
    const { data } = request
    const { id, ...rest } = data
    return instance().patch(`/v2/updateSop/${data.id}`, rest)
  },
  getStaffList: (request) => {
    const { config } = request
    return instance().get('/v2/getStaff', config)
  },
  getSopReport: (request) => {
    const { config } = request
    return instance().get('/v2/getSopReport', config)
  },
  updateSopStatus: (request) => {
    const { data } = request
    return instance().post('/v2/updateSopStatus', data)
  },
  importStaff: (request) => {
    const { data } = request
    return instance().post('/v2/importStaff', data)
  },
  changePassword: (request) => {
    const { data } = request
    return instance().post('/v2/changePassword', data)
  },
  updateStatusStaff: (request) => {
    const { data } = request
    return instance().post('/v2/updateStatusStaff', data)
  },
  getAnnouncementList: (request) => {
    const { config } = request
    return instance().get('/v2/getAnnouncement', config)
  },
  createAnnouncement: (request) => {
    const { data } = request
    return instance().post('/v2/createAnnouncement', data)
  },
  deleteAnnouncement: (request) => {
    const { data } = request
    return instance().post(`/v2/deleteAnnouncement/${data.id}`, { pageid: data.pageid })
  },
  updateAnnouncement: (request, id) => {
    const { data } = request
    return instance().post(`/v2/updateAnnouncement/${id}`, data)
  }
}
export default hopinnHrApi



// WEBPACK FOOTER //
// ./src/api/hopinn-hr.js